/**
 * Punte între butoanele „Comandă acum" ale landingului și formularul Releasit.
 *
 * Pe puffyair.ro aplicația rulează versiunea nouă de formular, care își
 * injectează formularul direct în ancora `_rsi-cod-form-embed-custom-hook`
 * din secțiunea `puffy-order`. Butonul deschide dialogul, iar formularul e
 * deja înăuntru.
 *
 * Pe produsefaine.ro aplicația e pe versiunea veche: ancora rămâne goală și
 * formularul se deschide doar din butonul propriu al aplicației. Fără puntea
 * asta, „Comandă acum" deschide un dialog gol și vizitatorul venit din
 * reclamă nu are cum să comande.
 *
 * Verificarea se face la fiecare click, nu o singură dată la încărcare. Dacă
 * magazinul e trecut mai târziu pe versiunea nouă de formular, ancora se
 * umple, puntea se dezactivează singură și pagina revine la comportamentul
 * nativ al temei. Nu rămâne nimic de curățat.
 */
(function () {
  // `.pbb__cta` e butonul propriu al temei din cardul de cumpărare. Pe
  // puffyair.ro el derulează la formularul care stă chiar în pagină; aici
  // formularul nu e în pagină, deci fără punte butonul n-ar face nimic.
  var OPENERS =
    '[data-puffy-open-order], .pbb__cta, a[href="#comanda"], a[href="#cumpara"], a[href="#cumpara-jos"]';
  var HOOK = '#_rsi-cod-form-embed-custom-hook';
  // Butonul de trimitere din formular poarta aceeasi clasa. Daca aplicatia ar
  // randa dialogul din start, el ar fi ales drept "deschizator" si un click pe
  // "Comanda acum" ar trimite formularul gol in loc sa il deschida.
  var RSI_BUTTON = '._rsi-buy-now-button:not(._rsi-modal-submit-button)';
  var FLOATING = '#_rsi-buy-now-button-floating';
  var THEME_BUTTON = '.pbb__cta';

  /** Formularul e deja în pagină? Atunci tema își face treaba singură. */
  function formIsEmbedded() {
    var hook = document.querySelector(HOOK);
    return !!(hook && hook.innerHTML.trim().length > 0);
  }

  /**
   * Readuce butonul propriu al temei.
   *
   * Aplicația e configurată cu „ascunde butonul de adăugare în coș", și îl
   * ascunde dintr-o foaie de stil servită de pe cdn.shopify.com. O regulă a
   * temei nu o poate bate: e `!important` cu selector mai specific, iar foaia
   * fiind pe alt domeniu nici nu poate fi citită ca să i se calculeze rangul.
   *
   * Un stil inline `!important` are precedență peste orice foaie de stil, deci
   * asta e singura cale sigură. Se repetă de câteva ori pentru că aplicația își
   * randează butoanele după încărcare, iar secțiunile temei se pot rehidrata.
   */
  function restoreThemeButtons() {
    var buttons = document.querySelectorAll(THEME_BUTTON);
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].style.setProperty('display', 'flex', 'important');
    }
  }

  /** Butonul aplicației pe care se apasă ca să se deschidă formularul. */
  function releasitButton() {
    var all = [].slice.call(document.querySelectorAll(RSI_BUTTON));

    // Butonul flotant al aplicatiei sta in DOM de la inceput, dar ramane
    // neinitializat pana il scoate ea; un click pe el atunci nu face nimic.
    // Cel din pagina e legat de la bun inceput, chiar daca stilul temei il
    // scoate din ecran.
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest(FLOATING)) return all[i];
    }
    return all[0] || null;
  }

  // Fază de capture: ascultătorii temei sunt puși direct pe butoane, deci
  // bubbling. Aici se decide înaintea lor, ca dialogul gol să nici nu apuce
  // să se deschidă.
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var opener = target.closest(OPENERS);
      if (!opener) return;

      if (formIsEmbedded()) return;

      var button = releasitButton();
      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      button.click();
    },
    true
  );
  restoreThemeButtons();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreThemeButtons);
  }
  [400, 1500, 4000].forEach(function (delay) {
    window.setTimeout(restoreThemeButtons, delay);
  });
})();
